/* Dropdayz — zwevende maatbalk + maatlade op collectiepagina's.
   Hoort bij snippets/ddz-maatbalk.liquid, die de maten server-side aanlevert
   in een JSON-blokje. Zie dat bestand voor het waarom en de cijfers.

   Het automatisch toepassen van een bewaarde maat zit NÍET hier maar in een
   inline-script in het snippet, zodat het draait vóór het raster getekend
   wordt. Anders zie je eerst de ongefilterde winkel en springt hij daarna.

   PAAR OF ITEM (26 aug 2026). Eigenaar: "ook het filter van kleding staat op
   paar". Het woord stond hier drie keer hard ingetypt. Het komt nu uit
   data-eenheid / data-eenheid-mv op de balk, gevuld door snippets/ddz-eenheid
   — dat leest het menu en weet dus of deze collectie onder Sneakers hangt.
   Type hier geen "paar" meer in. */
(function(){
  'use strict';

  var wortel = document.getElementById('ddz-maatbalk');
  if(!wortel) return;

  var bron = document.getElementById('ddz-maatbalk-data');
  if(!bron) return;

  var WAARDEN;
  try { WAARDEN = JSON.parse(bron.textContent); } catch(e){ return; }
  if(!WAARDEN || !WAARDEN.length) return;

  /* het woord voor één stuk en voor meer stuks; "paar" is in het Nederlands
     ook zijn eigen meervoud, "item" niet */
  var EEN = wortel.getAttribute('data-eenheid') || 'item';
  var MEER = wortel.getAttribute('data-eenheid-mv') || 'items';

  /* de melding blijft in de pagina staan; alleen de balk verhuist */
  var melding = document.getElementById('ddz-maatmelding');

  /* ---- EERST VERHUIZEN NAAR DE BODY ----
     position:fixed rekent niet tegen het scherm maar tegen de dichtstbijzijnde
     voorouder met een transform, filter of perspective. De balk staat in de
     collectiebalk, en daar zitten de reveal-animaties uit ddz-motion.js
     omheen — die zetten transform op hun container. Gevolg: de balk stond
     bijna 6000 px onder het scherm in plaats van 12 px erboven.
     Door het hele blok aan de body te hangen kan geen enkele voorouder er nog
     tussen komen. Kost niets en is definitief. */
  if(wortel.parentNode !== document.body) document.body.appendChild(wortel);

  var PARAM = 'filter.v.option.size';
  var SLEUTEL = 'ddz-maat';
  var LETTERS = ['XXS','XS','S','M','L','XL','XXL','3XL','4XL'];

  /* ---- groeperen op EU-getal ----
     Dezelfde maat bestaat vaak als meerdere variantwaarden ("EU 36 - US 4"
     en "EU 36 - US 4.5"). Zonder groeperen krijg je twee knoppen 36 die elk
     maar de helft van de paren tonen. */
  var groepen = {};
  WAARDEN.forEach(function(w){
    var g = groepen[w.eu] || (groepen[w.eu] = { eu:w.eu, waarden:[], aantal:0, actief:false });
    g.waarden.push(w.v);
    g.aantal += (w.n || 0);
    if(w.a) g.actief = true;
  });

  /* ---- sorteren ----
     Merkcollecties zoals Nike bevatten óók kleding, dus er zitten XS/S/M/L
     tussen de schoenmaten. Puur op parseFloat sorteren levert NaN op voor die
     letters, waarna de hele volgorde omvalt. */
  function sorteer(a, b){
    var na = parseFloat(a.eu), nb = parseFloat(b.eu);
    var aGetal = !isNaN(na), bGetal = !isNaN(nb);
    if(aGetal && bGetal) return na - nb;
    if(aGetal) return -1;
    if(bGetal) return 1;
    var ia = LETTERS.indexOf(String(a.eu).toUpperCase());
    var ib = LETTERS.indexOf(String(b.eu).toUpperCase());
    if(ia === -1) ia = 99;
    if(ib === -1) ib = 99;
    if(ia !== ib) return ia - ib;
    return String(a.eu).localeCompare(String(b.eu));
  }

  var lijst  = Object.keys(groepen).map(function(k){ return groepen[k]; }).sort(sorteer);
  var actief = lijst.filter(function(g){ return g.actief; }).map(function(g){ return g.eu; });
  var keuze  = actief.slice();          /* wat er in de lade aangetikt is */

  function urlMet(euLijst){
    var u = new URL(location.href);
    u.searchParams.delete(PARAM);
    u.searchParams.delete('page');
    euLijst.forEach(function(eu){
      var g = groepen[eu];
      if(!g) return;
      g.waarden.forEach(function(v){ u.searchParams.append(PARAM, v); });
    });
    return u.toString();
  }

  function ga(euLijst){
    try {
      /* met tijdstempel: het geheugen is een uur geldig, daarna vergeet de
         inline-check in het snippet hem. Wissen = meteen vergeten, anders
         komt het filter terug terwijl je het net had weggehaald. */
      if(euLijst.length) localStorage.setItem(SLEUTEL, JSON.stringify({ m:euLijst, t:Date.now() }));
      else localStorage.removeItem(SLEUTEL);
      /* zelf gekozen? dan hoeft de melding straks niet meer te vertellen dat
         er gefilterd wordt — dat weet je dan zelf. */
      sessionStorage.removeItem('ddz-maat-auto');
    } catch(e){}
    location.href = urlMet(euLijst);
  }

  /* op maatvolgorde tonen, niet op tikvolgorde — "41, 44" leest beter dan "44, 41" */
  function netjes(euLijst){
    return lijst.filter(function(g){ return euLijst.indexOf(g.eu) > -1; })
                .map(function(g){ return g.eu; });
  }

  var balkL  = wortel.querySelector('[data-ddz-mb-l]');
  var balkR  = wortel.querySelector('[data-ddz-mb-r]');
  var wisX   = wortel.querySelector('[data-ddz-mb-wisx]');
  var rij    = wortel.querySelector('[data-ddz-mb-rij]');
  var klaar  = wortel.querySelector('[data-ddz-mb-klaar]');

  var zichtbaar = parseInt(wortel.getAttribute('data-aantal'), 10);
  var totaal    = parseInt(wortel.getAttribute('data-totaal'), 10);
  var anders    = parseInt(wortel.getAttribute('data-anders'), 10) || 0;
  if(isNaN(zichtbaar)) zichtbaar = null;
  if(isNaN(totaal))    totaal = null;

  /* Staan er óók andere filters aan, dan is het collectietotaal geen eerlijke
     noemer: haal je de maat weg, dan zie je niet al die 357 paar maar alleen
     die van dat merk. Dan liever helemaal geen getal. */
  var eerlijk = (anders === 0 && totaal !== null && zichtbaar !== null);

  var pijl = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
             'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>';

  function ververBalk(){
    balkL.innerHTML = (actief.length
      ? 'Maat <em>' + netjes(actief).join(', ') + '</em>'
      : 'Filter op maat') + pijl;

    if(actief.length){
      /* het hele punt: naast "71" ook "van 357", zodat een laag getal niet
         leest als een lege winkel maar als een actief filter */
      balkR.textContent = eerlijk ? (zichtbaar + ' van ' + totaal)
                                  : (zichtbaar !== null ? zichtbaar + ' zichtbaar' : '');
    } else {
      balkR.textContent = totaal !== null ? totaal + ' ' + MEER : '';
    }

    if(wisX) wisX.hidden = !actief.length;
  }
  ververBalk();

  rij.innerHTML = lijst.map(function(g){
    return '<button type="button" class="ddz-mbz__pil' + (g.actief ? ' aan' : '') + '"' +
           ' data-eu="' + g.eu + '"' + (g.aantal ? '' : ' disabled') + '>' + g.eu +
           (g.aantal ? '<small>' + g.aantal + '</small>' : '') + '</button>';
  }).join('');

  function ververKnop(){
    if(!keuze.length){
      /* zelfde voorbehoud als op de balk: alleen een getal als het klopt */
      klaar.textContent = eerlijk ? ('Toon alle ' + totaal + ' ' + MEER) : 'Toon alle maten';
      return;
    }
    if(keuze.length === 1){
      var g = groepen[keuze[0]];
      var n = g ? g.aantal : 0;
      klaar.textContent = 'Toon ' + n + ' ' + (n === 1 ? EEN : MEER) + ' in maat ' + keuze[0];
      return;
    }
    /* Bij meerdere maten is de som géén goed getal: een paar dat zowel 44 als
       45 heeft telt dan dubbel. Liever geen getal dan een verkeerd getal. */
    klaar.textContent = 'Toon maat ' + netjes(keuze).join(', ');
  }
  ververKnop();

  Array.prototype.forEach.call(rij.querySelectorAll('.ddz-mbz__pil'), function(k){
    if(k.disabled) return;
    k.addEventListener('click', function(){
      var eu = k.dataset.eu;
      var i = keuze.indexOf(eu);
      if(i > -1) keuze.splice(i, 1); else keuze.push(eu);
      k.classList.toggle('aan', keuze.indexOf(eu) > -1);
      ververKnop();
    });
  });

  function zet(open){
    wortel.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if(!open){
      /* niet toegepaste keuzes terugdraaien, anders liegt de lade de
         volgende keer over wat er aanstaat */
      keuze = actief.slice();
      Array.prototype.forEach.call(rij.querySelectorAll('.ddz-mbz__pil'), function(k){
        k.classList.toggle('aan', keuze.indexOf(k.dataset.eu) > -1);
      });
      ververKnop();
    }
  }

  wortel.querySelector('[data-ddz-mb-open]').addEventListener('click', function(){ zet(true); });
  wortel.querySelector('[data-ddz-mb-waas]').addEventListener('click', function(){ zet(false); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') zet(false); });

  klaar.addEventListener('click', function(){ ga(keuze); });

  if(wisX) wisX.addEventListener('click', function(e){ e.stopPropagation(); ga([]); });

  var wis = wortel.querySelector('[data-ddz-mb-wis]');
  if(wis) wis.addEventListener('click', function(){
    if(actief.length) ga([]);
    else {
      keuze = [];
      Array.prototype.forEach.call(rij.querySelectorAll('.ddz-mbz__pil'), function(k){ k.classList.remove('aan'); });
      ververKnop();
    }
  });

  /* ---------- de melding ----------
     Alleen als de site het filter ZÉLF heeft teruggezet uit het geheugen.
     Het vlaggetje wordt gezet door het inline-script in ddz-maatbalk.liquid,
     vlak voordat het omleidt. We consumeren het meteen, en tonen de melding
     hooguit één keer per sessie — anders staat hij op elke collectiepagina
     opnieuw hetzelfde te vertellen.

     Onthullen gebeurt puur door het hidden-attribuut weg te halen. Er zit
     bewust géén requestAnimationFrame of klasse-toggle omheen: in een tab die
     op de achtergrond laadt vuurt dat niet, en dan bleef de melding op
     opacity:0 hangen terwijl het filter wél aanstond. De entree-animatie zit
     in de CSS en is enkel versiering. */
  (function(){
    if(!melding || !actief.length) return;

    var auto, alGemeld;
    try {
      auto = sessionStorage.getItem('ddz-maat-auto');
      if(auto !== null) sessionStorage.removeItem('ddz-maat-auto');
      alGemeld = sessionStorage.getItem('ddz-maat-gemeld');
    } catch(e){ return; }

    if(auto === null || alGemeld === '1') return;

    var doel = melding.querySelector('[data-ddz-mbm-maat]');
    var maten = netjes(actief);
    if(doel) doel.textContent = 'maat ' + maten.join(' en ');

    melding.hidden = false;

    try { sessionStorage.setItem('ddz-maat-gemeld', '1'); } catch(e){}

    var knop = melding.querySelector('[data-ddz-mbm-wis]');
    if(knop) knop.addEventListener('click', function(){ ga([]); });
  })();
})();
